/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import { Tag } from "antd";
import React from "react";
import { IssueStatus } from "../redux/slices/midservice/midserviceTypes";
import {
  CheckCircleFilled,
  ClockCircleFilled,
  CloseCircleFilled,
  DeleteFilled,
  PlayCircleFilled,
} from "@ant-design/icons";

interface StatusTagProps {
  status: "OFFLINE" | "ONLINE";
}

interface IssueStatusTagProps {
  status: keyof typeof IssueStatus;
}

const statusColorMap: Record<IssueStatus, string> = {
  [IssueStatus.OPENED]: "orange",
  [IssueStatus.WORKING]: "blue",
  [IssueStatus.RESOLVED]: "green",
  [IssueStatus.INCORRECT]: "red",
  [IssueStatus.DELETED]: "gray",
};

export const StatusIconMap: Record<string, any> = {
  OPENED: <ClockCircleFilled />,
  WORKING: <PlayCircleFilled />,
  RESOLVED: <CheckCircleFilled />,
  INCORRECT: <CloseCircleFilled />,
  DELETED: <DeleteFilled />,
};

export const StatusTag = ({ status }: StatusTagProps): JSX.Element => {
  return status === "OFFLINE" ? (
    <Tag color="red">{status}</Tag>
  ) : (
    <Tag color="green">{status}</Tag>
  );
};

export const IssueStatusTag = ({
  status,
}: IssueStatusTagProps): JSX.Element => {
  const text: IssueStatus = IssueStatus[status];
  const color: string = statusColorMap[text] || "black";

  return <Tag color={color}>{text}</Tag>;
};
